import {GET_BADGES} from "../storeConstants";

export function badgesReducer(state=[], action){
    switch(action.type) {
        case GET_BADGES:
            return action.payload;
        default:
            return state;
    }
}